/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component — «UI nuova» fork of the reschedule-event modal of the
 *              Area personale (step M18 bk-account): same class, nuova template
 *   extends:   RescheduleModalComponent
 *   template:  reschedule-modal-nuova.hbs
 *   args:      @event, @onConfirm, @onClose (as RescheduleModal)
 *   uses:      everything of RescheduleModal (loadSlotsTask, initCalendar,
 *              selectDate, selectSlot, changeMonth, confirmReschedule, close)
 *   siblings:  reschedule-modal.js (the logic, unchanged), user-nuova/events.hbs
 *              (the only caller)
 *   tests:     ui-nuova-bk-account-test.js
 *   gotchas:   template-only fork: no logic here. The dialog carries `nv-bk` so
 *              the booking calendar look (booking/_calendar.scss, scoped to
 *              .nv-bk) applies inside the portal under <body>.
 */
import RescheduleModalComponent from './reschedule-modal';

export default class RescheduleModalNuovaComponent extends RescheduleModalComponent {}
